import { Component, OnInit, Inject } from '@angular/core';
import { ChurchUnitsDataService } from '../../services';
import { ChurchUnit, UnitType } from '../../models';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { finalize } from 'rxjs/operators';

@Component({
  templateUrl: './select-church-unit.dialog.html',
  styleUrls: ['./select-church-unit.dialog.scss']
})
export class SelectChurchUnitDialog implements OnInit {
  enteredUnitNumber: string = null;
  searchingForUnit = false;
  selectedChurchUnit: ChurchUnit;
  unitNotFound = false;
  error: string = null;

  validUnitTypes: UnitType[];

  constructor(private churchUnitService: ChurchUnitsDataService, @Inject(MAT_DIALOG_DATA) public data: any) {}

  ngOnInit() {
    if (this.data.validUnitTypes) {
      this.validUnitTypes = this.data.validUnitTypes;
    }
  }

  /**
   * Looks up the church unit based on the entered unit number.
   */
  findChurchUnit(): void {
    if (!this.searchingForUnit && this.enteredUnitNumber) {
      this.searchingForUnit = true;
      this.selectedChurchUnit = null;
      this.unitNotFound = false;
      this.error = null;

      this.churchUnitService
        .getChurchUnit(this.enteredUnitNumber)
        .pipe(
          finalize(() => (this.searchingForUnit = false))
        )
        .subscribe(
          churchUnit => {
            this.handleResults(churchUnit);
          },
          error => {
            this.error = 'Unable to find church unit';
          }
        );
    }
  }

  /**
   * Handles the results of our search.  If nothing comes back, sets not found to true.  If we get something back,
   * then looks to see if we are supposed to be restricting based on unit type or not.  If so, takes those into account.
   */
  private handleResults(churchUnit: ChurchUnit): void {
    if (churchUnit == null) {
      this.unitNotFound = true;
    } else if (this.validUnitTypes) {
      if (churchUnit.unitType != null &&
          this.validUnitTypes.indexOf(churchUnit.unitType) > -1) {
        this.selectedChurchUnit = churchUnit;
      } else {
        this.error = `Invalid unit type; valid types are: ${this.validUnitTypes.join(', ')}`;
      }
    } else {
      this.selectedChurchUnit = churchUnit;
    }
  }
}
